import { render, staticRenderFns } from "./ViewDetailsPeerRating.vue?vue&type=template&id=20c64d8e"
import script from "./view-details-peer-rating.ts?vue&type=script&lang=ts&external"
export * from "./view-details-peer-rating.ts?vue&type=script&lang=ts&external"
import style0 from "./view-details-peer-rating.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports